import instance from "./dsdInstance";
import {API_URL} from "../config/api";

export default class AiDesignService {

    static publishDesign = async () => {
        try {
            const res = await instance.post(API_URL.AI_DESIGN + '/publish?type=AI_DESIGN');
            return res.data.data.result;
        } catch (e) {
            console.error(e);
        }
    }
    static deleteDesign = async id => {
        try {
            return  await instance.delete(API_URL.AI_DESIGN + '/' + id + '?type=AI_DESIGN');
        } catch (e) {
            console.error(e);
        }
    }
    static createDesign = async params => {
        try {
            return  await instance.post(API_URL.AI_DESIGN+ '?type=AI_DESIGN', params);
        } catch (e) {
            console.error(e);
        }
    }
    static editDesign = async params => {
        try {
            return  await instance.put(API_URL.AI_DESIGN + '?type=AI_DESIGN', params);
        } catch (e) {
            console.error(e);
        }
    }
    static getAllDesigns = async() => {
       try {
        console.log("getAllDesigns")
        const res =  await instance.get(API_URL.AI_DESIGN + '?type=AI_DESIGN');
        return res.data.data.result;
       } catch (e) {
           console.error(e);
       }
    }
}

